import React from 'react';
import InputWrapper from './InputWrapper';
import { getListeChoix } from './utils';

const RadioGroupInput = ({ field, fieldId, value, onChange, label, isRequired, error }) => {
  const radioOptions = getListeChoix(field);
  
  if (!radioOptions || radioOptions.length === 0) {
    return null;
  }
  
  const isHorizontal = field.affichageHorizontal !== false;
  
  const fieldWithDefault = {
    ...field,
    labelOnSameRow: field.labelOnSameRow !== undefined 
    ? field.labelOnSameRow : 
    label.length > 30 ? false : true
  };
  
  const radioInputs = (
    <div className={isHorizontal ? 'form-radio-group-horizontal' : ''}>
      {radioOptions.map((option, index) => (
        <div key={index} className="form-option-item">
          <input
            type="radio"
            id={`${fieldId}_${index}`}
            name={fieldId}
            value={option.value || option}
            checked={value === (option.value || option)}
            onChange={e => onChange(fieldId, e.target.value)}
            disabled={field.readOnly || false}
          />
          <label htmlFor={`${fieldId}_${index}`} className="form-option-label">
            {option.label || option}
          </label>
        </div>
      ))}
    </div>
  );
  
  return (
    <InputWrapper field={fieldWithDefault} label={label} isRequired={isRequired} error={error}>
      {radioInputs}
    </InputWrapper>
  );
};

export default RadioGroupInput;

